import { reducersActions } from "../actions/new-actions";

const {
    GET_BATCHES_REQUEST,
    GET_BATCHES_SUCCESS,
    GET_BATCHES_FAILURE,
} = reducersActions;

const initialState = {
  loading: false,
  data: [],
  error: null,
};

const voucherBatchReducerV3 = (state = initialState, action) => {
  switch (action.type) {
    case GET_BATCHES_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_BATCHES_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };

    case GET_BATCHES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default voucherBatchReducerV3;
